import { useState, useEffect } from 'react';
import { IRelease } from './types';

interface ReleaseData {
    releases: Array<Omit<IRelease, 'id'>>;
}

// Import the JSON file with proper typing
const initialReleasesData: ReleaseData = require('./initial-releases.json');

export const useReleases = () => {
    const [releases, setReleases] = useState<IRelease[]>([]);

    useEffect(() => {
        // Always load releases from the JSON file
        const releasesWithIds = initialReleasesData.releases.map((release: Omit<IRelease, 'id'>, index: number) => ({
            ...release,
            id: index.toString()
        }));
        setReleases(releasesWithIds);
    }, []);

    const addRelease = (release: IRelease) => {
        const newReleases = [release, ...releases];
        setReleases(newReleases);
    };

    const deleteRelease = (id: string) => {
        const newReleases = releases.filter(release => release.id !== id);
        setReleases(newReleases);
    };

    const updateRelease = (id: string, updatedRelease: Partial<IRelease>) => {
        const newReleases = releases.map(release =>
            release.id === id ? { ...release, ...updatedRelease } : release
        );
        setReleases(newReleases);
    };

    return {
        releases,
        addRelease,
        deleteRelease,
        updateRelease
    };
}; 